import React from 'react';

import Heading from '../Heading';

import './index.scss';

/*
  size = {small, medium, large}
*/
const IconCard = ({ size = 'medium', color = '', shadow = false, bgGray = true, icon, title }) => {
  const image = require(`../../../assets/imgs/icons/${icon}.svg`).default;

  return (
  	<>
	    <div className={'icon-card ' + size + (shadow ? ' shadow' : '') + (bgGray ? ' bg-gray' : '')}>
	      <img src={image} alt={icon}/>
	    </div>
	    {title && <Heading content={title} size="xxs" />}
	  </>
  )
};

export default IconCard;
